import { validateCpf } from 'pages/NewCartDocumets/utils/validators'

export { validateCpf as isValidCpf }

const VALID_DDDS = new Set(
  (
    '11 12 13 14 15 16 17 18 19 21 22 24 27 28 31 32 33 34 35 37 38 41 42 43 44 45 46 47 48 49 ' +
    '51 53 54 55 61 62 63 64 65 66 67 68 69 71 73 74 75 77 79 81 82 83 84 85 86 87 88 89 91 92 93 94 95 96 97 98 99'
  ).split(' ')
)

// Celular brasileiro: DDD válido + 9 dígitos começando em 9, com ou sem máscara.
export const isValidPhone = (value: string) => {
  const digits = value.replace(/\D/g, '')
  return digits.length === 11 && VALID_DDDS.has(digits.slice(0, 2)) && digits[2] === '9'
}

// usuario@dominio.ext: um único @, sem espaços, domínio com ponto e extensão de 2+ letras.
export const isValidEmail = (value: string) => /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[A-Za-z]{2,}$/.test(value.trim())

// DD/MM/AAAA real e não futura.
export const isValidBirthdayMask = (value: string) => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value)
  if (!match) return false
  const [, day, month, year] = match.map(Number)
  const date = new Date(year, month - 1, day)
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day &&
    date.getTime() <= Date.now()
  )
}

export const PHONE_ERROR = 'Informe um celular com DDD, ex.: (11) 91234-5678'
export const EMAIL_ERROR = 'Informe um e-mail válido, ex.: nome@dominio.com'
export const CPF_ERROR = 'CPF inválido'
